import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initScrollVideo() {
    for(const videoElement of document.querySelectorAll('.contactBanner__media video')){
        videoElement.pause();
        videoElement.currentTime = 0;
        videoElement.loop = true;

        ScrollTrigger.create({
            trigger: videoElement,
            start: 'top 50%',
            onEnter: () => {
                videoElement.play();
            },
            markers: false
        });
    }
}
